import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';

const MockupDots = styled('div')`
  display: flex;
  gap: 5px;
  flex-shrink: 0;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #e2e8f0;
  }
`;

export const ProductMockupFrame = styled('div')`
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(14, 28, 43, 0.08);
`;

export const ProductMockupBody = styled('div')`
  padding: 16px 18px 18px;
  background: #f6f6f4;
`;

const MockupChromeHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
`;

const BrandRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const BrandLogo = styled('img')`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`;

const BrandName = styled('span')`
  font-size: 13px;
  font-weight: 700;
  color: ${COLORS.INK};
  white-space: nowrap;
`;

const ProductPath = styled('span')`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AgentChromeHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid ${COLORS.GRAY.borderLight};
  background: ${COLORS.WHITE};
`;

const AgentChromeName = styled('div')`
  font-size: 13px;
  font-weight: 700;
  color: ${COLORS.INK};
`;

const AgentChromeStatus = styled('div')`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.GRAY.muted};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${COLORS.GREEN.green6};
    box-shadow: 0 0 6px rgba(82, 196, 26, 0.7);
  }
`;

export const AppMockupChrome = ({
  product,
  surface
}: {
  product: 'Unify' | 'Amplify' | 'Optimize';
  surface: string;
}) => (
  <MockupChromeHeader>
    <BrandRow>
      <BrandLogo src="/favicon.png" alt="" />
      <BrandName>Affilimate</BrandName>
      <ProductPath>
        · {product} · {surface}
      </ProductPath>
    </BrandRow>
    <MockupDots>
      <span />
      <span />
      <span />
    </MockupDots>
  </MockupChromeHeader>
);

export const AgentMockupChrome = ({
  status = 'Connected'
}: {
  status?: string;
}) => (
  <AgentChromeHeader>
    <BrandLogo src="/favicon.png" alt="" />
    <AgentChromeName>Affilimate Agent</AgentChromeName>
    <AgentChromeStatus>{status}</AgentChromeStatus>
  </AgentChromeHeader>
);
